import React from 'react';
import { buildCellClass } from '../../../utils/calendar';

const CalendarCellGrid = ({ gridClassName, cellClassName, cells, onPick, children }) => (
  <div className={gridClassName}>
    {children}
    {cells.map((cell) => (
      <button
        key={cell.key}
        type="button"
        className={buildCellClass(cellClassName, { isToday: cell.isToday, isSelected: cell.isSelected, extra: cell.extra })}
        data-testid={cell.testId}
        disabled={cell.isDisabled}
        onClick={() => onPick(cell.value)}
      >
        {cell.label}
      </button>
    ))}
  </div>
);

export default CalendarCellGrid;
